import truncate from 'html-truncate';
import React from 'react';
import FontAwesome from 'react-fontawesome';
import Router, { Link } from 'react-router-dom';
import Select from 'react-select';

import BreadcrumbTrail from 'components/global/application/BreadcrumbTrail';
import SlickCarousel from 'components/global/application/SlickCarousel';
import Button from 'components/global/form/Button';
import Product from 'types/shopify/Product';
import Variants from './Variants';

import CartItem from 'types/shopify/CartItem';

import './AccessoryDetail.sass';

export interface OwnProps {
    match: Router.match<{ product_id: number }>;
}

export interface StateProps {
    isMobile: boolean;
    product: Product;
    isLoading: boolean;
}

export interface DispatchProps {
    addToCart(item: CartItem): void;
    displayCartMessage(value: string): void;
}

interface State {
    mainImageIndex: number;
    selectedQuantity: number;
    selectedVariant: number;
    message: boolean;
}

type CombinedProps = OwnProps & StateProps & DispatchProps;

class AccessoryDetail extends React.Component<CombinedProps, State> {
    private messageTimeout: number;   // TODO: May need to move this to AccessoriesPage and pass it in as a prop along with displayCartMessage. Clearing timeout in willunmount as stop-gap

    constructor(props: CombinedProps) {
        super(props);

        this.state = {
            mainImageIndex: 0,
            message: false,
            selectedQuantity: 1,
            selectedVariant: 0
        };
    }

    public componentWillMount() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    }

    public componentWillUnmount() {
        this.clearCurrentMessage();
    }

    public render() {
        const { isMobile, product, isLoading, match } = this.props;
        const { selectedVariant, mainImageIndex } = this.state;
        return isLoading
        ? (<FontAwesome className="loading-spinner" name="spinner" size="3x" spin />) // SPINNER
        : (
            <div className="row accessory-detail">
                <div className="col-10 offset-1">
                    <div className="row detail-breadcrumb">
                        <div className="col-12">
                            <BreadcrumbTrail pathNodes={[{ label:'Accessories', route:'/accessories' }, { label: product.title, route: `/accessories/${match.params.product_id}` }]} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            {isMobile && <h3 className="accessory-label">{product.title}</h3>}
                            <div className="image-wrapper">
                                <img className="main-image" src={product.images[mainImageIndex].src} alt="" />
                                {product.images.length > 1 && <SlickCarousel imageSources={product.images.map(i => i.src)} onClick={this.handleSlideClick} />}
                            </div>
                        </div>
                        <div className="col-md-9">
                            <h3 className="accessory-label">{product.title}</h3>
                            <div className="description"><div dangerouslySetInnerHTML={{ __html: product.body_html }} /></div>
                            <Variants handleVariantSelect={this.handleVariantSelect} variants={product.variants} selectedItem={selectedVariant} />
                            <Select
                                className="quantity-select"
                                name="quantity-select"
                                value={this.state.selectedQuantity}
                                onChange={this.handleQuantitySelect}
                                searchable={false}
                                clearable={false}
                                autosize={false}
                                options={Array.apply(null, { length: 31 }).map(Number.call, Number).slice(1).map((n: number) => {
                                    return { value: n, label: n };
                                })}
                            />
                            <Button className="btn-add-cart" onClick={this.handleAddButtonClicked} >Add To Cart</Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    protected clearCurrentMessage = (timeoutOnly?: boolean) => {
        if (this.messageTimeout > 0) window.clearTimeout(this.messageTimeout);
        if (!timeoutOnly) this.props.displayCartMessage('');
    }

    protected handleSlideClick = (imageIndex: number) => {
        this.setState({ mainImageIndex: imageIndex });
    }

    protected handleVariantSelect = (selection: number) => {
        this.setState({ selectedVariant: selection });
        this.clearCurrentMessage();
    }

    protected handleQuantitySelect = (selection: { value?: number, label: string }) => {
        this.setState({ selectedQuantity: selection.value });
        this.clearCurrentMessage();
    }

    protected handleAddButtonClicked = () => {
        const { product } = this.props;
        const { selectedVariant, selectedQuantity } = this.state;
        this.props.addToCart({
            addedTime: new Date(),
            field_gruhn_category_id: '',
            imageSrc: product.images && (product.images[selectedVariant] ? product.images[selectedVariant].src  : ''),
            price: parseFloat(product.variants[selectedVariant].price),
            productId: product.id,
            quantity: selectedQuantity,
            title: `${product.title} | ${product.variants[selectedVariant].title}`,
            type: 'Accessory',
            variantId: product.variants[selectedVariant].id
        });
        this.clearCurrentMessage(true); // We want a fresh timer for new messages
        const wasWere = this.state.selectedQuantity > 1 ? 'were' : 'was';
        this.props.displayCartMessage(`${selectedQuantity} ${product.title} | ${product.variants[selectedVariant].title}  ${wasWere}`);
        this.messageTimeout = window.setTimeout(() => this.props.displayCartMessage(''), 15000, []);
    }
}

const AccessoryDetailStatelessWrapper: React.StatelessComponent<CombinedProps> = (props: CombinedProps) => (<AccessoryDetail {...props} />);

export default AccessoryDetailStatelessWrapper;



// WEBPACK FOOTER //
// ./src/components/pages/accessories/detail/AccessoryDetail.tsx